import React from "react";
import { Text } from "@hangar/web-components/core/Text";
import { Button } from "@hangar/web-components/core/Button";
import { useAppConfig } from "../../hooks/config/useAppConfig";
import { ConfigInfo } from "./ConfigInfo";
import {
  Container,
  ErrorContainer,
  InfoBox,
  InfoParagraph,
  Section,
  ButtonsContainer,
  Code,
  ButtonContainer,
} from "./ConfigExample.styles";

/**
 * Componente de ejemplo que muestra cómo usar la configuración cargada desde JSON
 */
export const ConfigExample: React.FC = () => {
  const { config, loading, error, reload } = useAppConfig();

  if (loading) {
    return (
      <Container>
        <Text variant="heading-md">Configuration Example</Text>
        <Text>Loading configuration from JSON...</Text>
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <Text variant="heading-md">Configuration Example</Text>
        <ErrorContainer>
          <Text variant="body-sm">
            Error loading configuration: <Text bold>{error?.message}</Text>
          </Text>
        </ErrorContainer>
        <Button onClick={reload}>Retry</Button>
      </Container>
    );
  }

  return (
    <Container>
      <Text variant="heading-md">Configuration Example</Text>
      <Text variant="body-md">
        This example shows how to access configuration loaded from JSON file.
      </Text>

      <Section>
        <Text variant="heading-sm">Application Info</Text>
        <InfoBox>
          <InfoParagraph>
            <Text variant="body-sm">
              Environment: <Text bold>{config?.environment}</Text>
            </Text>
          </InfoParagraph>
        </InfoBox>
      </Section>

      <Section>
        <Text variant="heading-sm">Authentication Config</Text>
        <InfoBox>
          <InfoParagraph>
            <Text variant="body-sm">
              Client ID: <Text bold>{config?.auth.clientId.substring(0, 8)}...</Text>
            </Text>
          </InfoParagraph>
          <InfoParagraph>
            <Text variant="body-sm">
              Authority: <Text bold>{config?.auth.authority}</Text>
            </Text>
          </InfoParagraph>
          <InfoParagraph>
            <Text variant="body-sm">
              Redirect URI: <Text bold>{config?.auth.redirectUri}</Text>
            </Text>
          </InfoParagraph>
          <InfoParagraph>
            <Text variant="body-sm">
              Post Logout URI: <Text bold>{config?.auth.postLogoutRedirectUri}</Text>
            </Text>
          </InfoParagraph>
        </InfoBox>
      </Section>

      <Section>
        <Text variant="heading-sm">Configuration Source</Text>
        <Text variant="body-sm">
          Configuration loaded from: <Code>/assets/config/configuration.json</Code>
        </Text>
        <Text variant="body-sm">
          This file is generated by the deployment pipeline with environment-specific values.
        </Text>
      </Section>

      <Section>
        <Text variant="heading-sm">Debug Information</Text>
        <ConfigInfo />
      </Section>

      <ButtonsContainer>
        <ButtonContainer>
          <Button variant="primary" onClick={reload} label="Reload Configuration" />
        </ButtonContainer>
        <ButtonContainer>
          <Button
            variant="secondary"
            onClick={() => {
              console.log("Current configuration:", config);
              alert("Configuration logged to console");
            }}
            label="Log to Console"
          />
        </ButtonContainer>
      </ButtonsContainer>
    </Container>
  );
};
